// extracted by mini-css-extract-plugin
export var cardIcon = "_5p-5";
export var checkboxCard = "_5p-0";
export var checkboxCardSelected = "_5p-4";
export var disabled = "_5p-2";
export var interactive = "_5p-1";
export var outerBorder = "_5p-3";
export var spacerMedium = "_5p-8";
export var spacerSmall = "_5p-7";
export var spacerXsmall = "_5p-6";